<div class="wrap">
  <div class="card">

    <!-- ══════ CARD HEADER ══════ -->
    <div class="card-header" *ngIf="!inline">
      <div class="title">
        <div>
          <h1>{{ 'equipements.page.title' | translate }}</h1>
          <p class="subtitle">{{ 'equipements.page.subtitle' | translate }}</p>
        </div>
      </div>
      <div class="header-actions">
        <select class="filter-select" *ngIf="data()"
                [value]="filterSiteId()"
                (change)="filterSiteId.set($any($event.target).value)">
          <option value="">{{ 'equipements.page.allSites' | translate }}</option>
          <option *ngFor="let e of session.establishments()" [value]="e.id">{{ e.name }}</option>
        </select>
        <button class="btn-add" (click)="openUpsert(null)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          {{ 'equipements.page.addSensor' | translate }}
        </button>
      </div>
    </div>

    <!-- ══════ CARD BODY ══════ -->
    <div class="card-body">

      <!-- État chargement -->
      <div *ngIf="loading()" class="state-loading">{{ 'equipements.page.loading' | translate }}</div>

      <!-- État erreur -->
      <div *ngIf="error()" class="state-error">{{ 'equipements.page.error' | translate }}</div>

      <ng-container *ngIf="data() as d">

        <!-- KPI — cliquables pour filtrer le tableau -->
        <div class="kpi-row">
          <div class="hcard" [class.hcard-active]="filterStatus() === 'all'"
               (click)="filterStatus.set('all')" [attr.title]="'equipements.kpi.filterAllTooltip' | translate">
            <span class="hcard-label">{{ 'equipements.kpi.sensorsLabel' | translate }}</span>
            <span class="hcard-value">{{ siteStats().total }}</span>
          </div>
          <div class="hcard hcard-ok" [class.hcard-active]="filterStatus() === 'OK'"
               (click)="filterStatus.set('OK')" [attr.title]="'equipements.kpi.filterOnlineTooltip' | translate">
            <span class="hcard-label">{{ 'equipements.kpi.onlineLabel' | translate }}</span>
            <span class="hcard-value">{{ siteStats().enLigne }}</span>
          </div>
          <div class="hcard" [class.hcard-danger]="siteStats().offline > 0"
               [class.hcard-active]="filterStatus() === 'Offline'"
               (click)="filterStatus.set('Offline')" [attr.title]="'equipements.kpi.filterOfflineTooltip' | translate">
            <span class="hcard-label">{{ 'equipements.kpi.offlineLabel' | translate }}</span>
            <span class="hcard-value">{{ siteStats().offline }}</span>
          </div>
          <div class="hcard" [class.hcard-warn]="siteStats().instable > 0"
               [class.hcard-active]="filterStatus() === 'Instable'"
               (click)="filterStatus.set('Instable')" [attr.title]="'equipements.kpi.filterUnstableTooltip' | translate">
            <span class="hcard-label">{{ 'equipements.kpi.unstableLabel' | translate }}</span>
            <span class="hcard-value">{{ siteStats().instable }}</span>
          </div>
          <div class="hcard" [class.hcard-warn]="siteStats().batterieFaible > 0"
               [class.hcard-active]="filterStatus() === 'batterieFaible'"
               (click)="filterStatus.set('batterieFaible')" [attr.title]="'equipements.kpi.filterLowBatteryTooltip' | translate">
            <span class="hcard-label">{{ 'equipements.kpi.lowBatteryLabel' | translate }}</span>
            <span class="hcard-value">{{ siteStats().batterieFaible }}</span>
          </div>
        </div>

        <!-- Tableau -->
        <div class="table-block">
          <div class="table-header-row">
            <span class="col-capteur th-search-col">
              <ng-container *ngIf="!searchOpen()">
                {{ 'equipements.table.sensorColumn' | translate }}
                <button class="th-search-btn" (click)="searchOpen.set(true)" [attr.title]="'equipements.table.searchTooltip' | translate" [class.th-search-btn--active]="searchQuery()">
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                </button>
              </ng-container>
              <span class="th-search-inline" *ngIf="searchOpen()">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                <input class="th-search-input" type="text" [placeholder]="'equipements.table.searchPlaceholder' | translate"
                       [value]="searchQuery()"
                       (input)="searchQuery.set($any($event.target).value)"
                       (keydown.escape)="closeSearch()"
                       autofocus>
                <button class="th-search-clear" (click)="closeSearch()">×</button>
              </span>
            </span>
            <span class="col-lieu">{{ 'equipements.table.siteColumn' | translate }}</span>
            <span class="col-statut">{{ 'equipements.table.statusColumn' | translate }}</span>
            <span class="col-donnee">{{ 'equipements.table.lastFrameColumn' | translate }}</span>
            <span class="col-comptage">{{ 'equipements.table.periodColumn' | translate }}</span>
            <span class="col-cumul">{{ 'equipements.table.cumulativeColumn' | translate }}</span>
            <span class="col-signal">{{ 'equipements.table.signalColumn' | translate }}</span>
            <span class="col-batterie">{{ 'equipements.table.batteryColumn' | translate }}</span>
            <span class="col-action"></span>
          </div>

          <div class="table-row" *ngFor="let e of filteredEquipements()"
               [class.row-offline]="e.statut === 'Offline'"
               [class.row-instable]="e.statut === 'Instable'">

            <!-- Capteur -->
            <span class="col-capteur">
              <span class="capteur-name">{{ e.capteur }}</span>
            </span>

            <!-- Site -->
            <span class="col-lieu">{{ e.establishmentName || '—' }}</span>

            <!-- Statut -->
            <span class="col-statut">
              <span class="statut-dot" [ngClass]="getStatutClass(e.statut)"></span>
              <span class="statut-label" [ngClass]="getStatutClass(e.statut)">{{ getStatutLabelKey(e.statut) | translate }}</span>
            </span>

            <!-- Dernière trame -->
            <span class="col-donnee" [ngClass]="getDonneeClass(e.derniereTrameAt)">{{ formatDerniereDonnee(e.derniereTrameAt) }}</span>

            <!-- Comptage période -->
            <span class="col-comptage">
              <span class="count-row">
                <span class="count-in">↑ {{ getCount(e, 'periodicIn') }}</span>
                <span class="count-out">↓ {{ getCount(e, 'periodicOut') }}</span>
              </span>
            </span>

            <!-- Cumulé -->
            <span class="col-cumul">
              <span class="count-row">
                <span class="count-in">↑ {{ getCount(e, 'accumulatedIn') }}</span>
                <span class="count-out">↓ {{ getCount(e, 'accumulatedOut') }}</span>
              </span>
            </span>

            <!-- Signal -->
            <span class="col-signal">
              <ng-container *ngIf="!e.simulated || e.rssi !== null">
                <span class="signal-line" [ngClass]="getRssiClass(e.rssi)">{{ formatRssi(e.rssi) }}</span>
                <span class="signal-sub">SNR {{ formatSnr(e.snr) }} · {{ formatSf(e.spreadingFactor) }}</span>
              </ng-container>
            </span>

            <!-- Batterie -->
            <span class="col-batterie">
              <ng-container *ngIf="!e.simulated || e.batterie !== null || e.nodeBatterie !== null">
                <div class="bat-group" *ngIf="!e.simulated || e.batterie !== null">
                  <span class="bat-label">M</span>
                  <div class="bat-bar-track">
                    <div class="bat-bar-fill" [style.width.%]="getBatterie(e)" [ngClass]="getBatterieClass(e.batterie)"></div>
                  </div>
                  <span class="bat-val">{{ e.batterie !== null ? (e.batterie + '%') : '—' }}</span>
                </div>
                <div class="bat-group" *ngIf="e.nodeBatterie !== null">
                  <span class="bat-label">N</span>
                  <div class="bat-bar-track">
                    <div class="bat-bar-fill" [style.width.%]="e.nodeBatterie" [ngClass]="getBatterieClass(e.nodeBatterie)"></div>
                  </div>
                  <span class="bat-val">{{ e.nodeBatterie }}%</span>
                </div>
              </ng-container>
            </span>

            <!-- Action -->
            <span class="col-action">
              <button class="action-icon-btn" [attr.title]="'equipements.table.editTooltip' | translate" (click)="openUpsert(e)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
              <button class="action-icon-btn" [attr.title]="'equipements.table.detailTooltip' | translate" (click)="openDetail(e)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
              </button>
              <button class="action-icon-btn action-icon-btn--danger" [attr.title]="'equipements.table.deleteTooltip' | translate" (click)="openDelete(e)">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                  <path d="M10 11v6M14 11v6"/>
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                </svg>
              </button>
            </span>
          </div>

          <div class="table-empty" *ngIf="filteredEquipements().length === 0">
            {{ (filterSiteId() ? 'equipements.table.emptySite' : 'equipements.table.emptyNetwork') | translate }}
          </div>
        </div>

      </ng-container>
    </div>

  </div>
</div>

<!-- Loader overlay pendant la récupération du détail -->
<div class="detail-loading-overlay" *ngIf="detailLoading()">
  <div class="detail-loading-spinner"></div>
</div>

<!-- Modal détail capteur -->
<app-capteur-detail-modal
  *ngIf="selectedDetail()"
  [detail]="selectedDetail()!"
  (close)="closeDetail()">
</app-capteur-detail-modal>

<!-- Modal ajouter / modifier capteur -->
<app-capteur-upsert-modal
  *ngIf="upsertSensor() !== null"
  [sensor]="upsertSensorForModal"
  [queues]="queues()"
  [establishments]="session.establishments()"
  [initialEstablishmentId]="upsertEstablishmentId()"
  [saving]="saving()"
  [saveError]="saveError()"
  (save)="onSave($event)"
  (close)="closeUpsert()"
  (establishmentChange)="onModalEstablishmentChange($event)">
</app-capteur-upsert-modal>

<!-- Modale de confirmation de suppression -->
<app-confirm-modal
  *ngIf="deleteOpen()"
  [title]="'equipements.deleteModal.title' | translate"
  [message]="'equipements.deleteModal.message' | translate: { name: $safeNavigationMigration(deleteTarget()?.capteur) }"
  [confirmText]="'equipements.common.delete' | translate"
  [cancelText]="'equipements.common.cancel' | translate"
  [loading]="deleteLoading()"
  [errorMessage]="deleteError()"
  (confirm)="confirmDelete()"
  (cancel)="closeDelete()">
</app-confirm-modal>
